{
  "actions": "Handlinger",
  "actionsAvailable": "Tilgjengelige handlinger.",
  "clearSelection": "Tøm utvalg",
  "selected": "Valde element: {count}",
  "selectedAll": "Alle er valgt"
}
